import React, {useContext, useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { DropdownContext } from '../../utils/constants';
import DropdownSelect from '../DropdownSelect';

const useStyles = makeStyles(() => ({
    helpContainer: {
        padding: '2%',
        width: '50%',
        background: 'rgba(110, 247, 138, 0.1)',
        marginLeft: '2rem'
    },
    practiceDropdown: {
        width: '50%'
    }
}));

const priorityPracticeDefinitions = {
    'Strategy Clarity': 'Articulating a clear direction and strategy for winning, and translating it into specific goals and targets.',

  'Shared Vision': 'Setting the direction by creating and communicating a compelling, vivid image of what the future will look like.',
  'Strategic Clarity': 'Articulating a clear direction and strategy for winning, and translating it into specific goals and targets.',
  'Employee Involvement': 'Engaging employees in dialogue on the direction of the organization and discussing their part in making it happen.',
  'Authoritative Leadership': 'Leaders emphasize hierarchy and managerial pressure to get things done.',
  'Consultative Leadership': 'Leaders involve and empower employees through communication, consultation and delegation.',
  'Supportive Leadership': 'Leaders build a positive environment characterized by team harmony, support, and caring for employees’ welfare.',
  'Challenging Leadership': 'Leaders encourage employees to take on challenges and do more than they thought was possible.',
  'Open & Trusting': 'Encouraging honesty, transparency and candid, open dialogue.',
  'Performance Transparency': 'Making results visible to enable best practice sharing and foster a healthy sense of cooperation and collaboration.',
  'Operationally Disciplined': 'Fostering clear behavioural and performance standards, while monitoring the adherence to those standards.',
  'Creative & Entrepreneurial': 'Supporting innovation, creativity, and initiative-taking',
  'Role Clarity': 'Getting clear on what everyone is responsible for, has authority over, and who to work with.',
  'Performance Contracts': 'Accountability driven by clear objectives and formal, explicit performance targets.',
  'Consequence Management': 'Accountability driven by linking rewards and consequences to individual performance.  ',
  'Personal Ownership': 'Accountability driven by a strong sense of individual ownership and personal responsibility.',
  'Talent Acquisition': 'Hiring the right talent.',
  'Talent Development': 'Developing employees’ knowledge and skills.',
  'Process Based Capabilities': 'Embedding standardized systems, processes and procedures to eliminate work-arounds. ',
  'Outsourced Expertise': 'Using external resources to fill capability gaps (e.g., consultants, vendors, business partners). ',
  'People Performance Review': 'Use formal performance assessments, feedback, and tracking to coordinate and control flows of talent.',
  'Operational Management': 'Focus on operational Key Performance Indicators (KPIs), metrics and targets to monitor and manage business performance.',
  'Financial Management': 'Focusing on financial Key Performance Indicators (KPIs) and the effective allocation and control of financial resources to monitor and manage performance.',
  'Professional Standards': 'Use clear standards, policies, and rules to set behavioral expectations and enforce compliance.',
  'Risk Management': 'Identifying and mitigating anticipated risks, and responding rapidly to unexpected problems as they arise.',
  'Meaningful Values': 'Sharing and living a meaningful set of values day-to-day.',
  'Inspirational Leaders': 'Inspiring employees through encouragement, guidance and recognition.',
  'Career Opportunities': 'Providing career and development opportunities to motivate employees.',
  'Financial Incentives': 'Using performance-related financial rewards to motivate employees.',
  'Rewards & Recognition': 'Providing non-financial rewards and recognition to encourage high performance.',
  'Top-Down Innovation': 'Driving innovation and learning through high-priority initiatives sponsored by senior leaders.',
  'Bottom-Up Innovation': 'Supporting innovation, creativity, and initiative-taking.',
  'Knowledge Sharing': 'Enabling collaboration and knowledge sharing across the company.',
  'Capturing External Ideas': 'Identifying and using best practices from outside the company.',
  'Customer Focus': 'Putting internal and external customer needs at the forefront of the decision-making process.',
  'Competitive Insights': 'Acquiring and using information about competitors to inform business decisions.',
  'Business Partnerships': 'Building and maintaining a network of external business partners.',
  'Government & Community Relations': 'Developing strong relationships with the public, local communities, government and regulatory agencies.',
};

export default function OrganizationHealthCard({ impact, updateImpact, disabled }) {
    const classes = useStyles();
    const { dropdowns } = useContext(DropdownContext);
    const [ priorityPractice, setPriorityPractice ] = useState(impact.priorityPracticeId);
    const [ engagementPlan, setEngagementPlan ] = useState(impact.engagementPlan);

    useEffect(() => {
      setPriorityPractice(impact.priorityPracticeId);
      setEngagementPlan(impact.engagementPlan);
    }, [impact.priorityPracticeId, impact.engagementPlan]);

    const getDefinition = () => {
        return priorityPracticeDefinitions[dropdowns['PriorityPractice'][priorityPractice]] || '';
    };

    const onPriorityPracticeChange = (e) => {
        updateImpact(impact.id, 'priorityPracticeId', e.target.value, () => { setPriorityPractice(e.target.value); })
    };

    const onEngagementPlanChange = (e) => {
      setEngagementPlan(e.target.value);
    }

    const onEngagementPlanBlur = (e) => {
        updateImpact(impact.id, 'engagementPlan', e.target.value, () => { })
    }

    return (
        <div style={{width: '100%'}}>
            <Typography variant='body1' style={{width: '100%'}}>
              What is the Priority Practice you are promoting with this initiative and how are we measuring the change?
            </Typography>
            <br/>
            <div style={{display: 'flex', width: '100%'}}>
                <DropdownSelect
                    variant='outlined'
                    controlClass={classes.practiceDropdown}
                    label='Priority Practice'
                    labelId='priority-practice-label'
                    onChange={onPriorityPracticeChange}
                    value={priorityPractice || ''}
                    dropdownName={'PriorityPractice'}
                    disabled={disabled}
                />
                <div className={classes.helpContainer}>
                    {getDefinition()}
                </div>
            </div>

            <Typography style={{width: '100%'}} variant='button'>
                Engagement Plan
            </Typography>
            <TextField
                multiline
                fullWidth
                placeholder='Please describe your plan for improving this Priority Practice with this initiative.'
                variant='outlined'
                value={engagementPlan || ''}
                onChange={onEngagementPlanChange}
                onBlur={onEngagementPlanBlur}
                disabled={disabled}
            />
        </div>
    );
}
